import { DialogObject } from '@/components/dialog/dialog.types';
import { CurrencyRepository } from '@/store/currency-state/currency-state.repository';
import { TranslateService } from '@ngx-translate/core';

interface IgetCurrencyDeleteObjectProps {
  t: TranslateService;
  store?: CurrencyRepository;
  action?: () => void;
  toggleVisiblity?: () => void;
}

export const getCurrencyDeleteObject = ({ t, store, action, toggleVisiblity }: IgetCurrencyDeleteObjectProps): DialogObject => {
  return {
    title: t.instant('settings.currency.delete.title'),
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'settings.currency.delete.confirm',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'settings.currency.delete.cancel',
        onClick: () => {
          toggleVisiblity?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
